module.exports = __webpack_public_path__ + "img/summer_100x100.70faa68b.png";